const v = (name: string, outputs: readonly { type: string; name?: string }[], inputs: readonly { type: string; name: string }[] = []) =>
  ({ type: 'function', name, stateMutability: 'view', inputs, outputs }) as const;

export const addressesRegistryAbi = [
  v('collateralRegistry', [{ type: 'address' }]), v('boldToken', [{ type: 'address' }]), v('troveManager', [{ type: 'address' }]),
  v('stabilityPool', [{ type: 'address' }]), v('activePool', [{ type: 'address' }]), v('priceFeed', [{ type: 'address' }]),
  v('collToken', [{ type: 'address' }]), v('CCR', [{ type: 'uint256' }]), v('SCR', [{ type: 'uint256' }]), v('MCR', [{ type: 'uint256' }]),
] as const;

export const collateralRegistryAbi = [
  v('totalCollaterals', [{ type: 'uint256' }]),
  v('getTroveManager', [{ type: 'address' }], [{ name: 'index', type: 'uint256' }]),
  v('baseRate', [{ type: 'uint256' }]),
  v('getRedemptionRateWithDecay', [{ type: 'uint256' }]),
] as const;

export const troveManagerAbi = [
  v('shutdownTime', [{ type: 'uint256' }]),
  v('getEntireBranchDebt', [{ type: 'uint256' }]),
  v('getEntireBranchColl', [{ type: 'uint256' }]),
] as const;

/** Σ(trove debt × annual interest rate), both 1e18-scaled: BOLD interest per year × 1e36. */
export const activePoolAbi = [v('aggWeightedDebtSum', [{ type: 'uint256' }])] as const;

export const stabilityPoolAbi = [
  v('getTotalBoldDeposits', [{ type: 'uint256' }]),
  v('getCollBalance', [{ type: 'uint256' }]),
  v('getYieldGainsOwed', [{ type: 'uint256' }]),
  v('getCompoundedBoldDeposit', [{ type: 'uint256' }], [{ name: 'depositor', type: 'address' }]),
  v('getDepositorCollGain', [{ type: 'uint256' }], [{ name: 'depositor', type: 'address' }]),
  v('getDepositorYieldGain', [{ type: 'uint256' }], [{ name: 'depositor', type: 'address' }]),
] as const;

export const priceFeedAbi = [v('lastGoodPrice', [{ type: 'uint256' }])] as const;

export const BOLD_TOKEN = '0x6440f144b7e50D6a8439336510312d2F54beB01D' as const;
